import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, map, Observable, throwError } from 'rxjs';

import { Colleague, UserOrganigramaSearchPayload } from '../interfaces/common.interface'
import { SearchEntitate } from '../components/entitati/entitati.interface';
import { Generic, GenericCompartimentSearch } from '../interfaces/generic.interface';

@Injectable({
    providedIn: 'root'
})
export class CommonService {
    private basePath = environment.interop.basePath;
    private basePathAuth = environment.interop.authCore.basePath;

    private getDirectiiUrl = this.basePath + environment.interop.indoc.directie.getDirectii
    private getDirectiiActiveUrl = this.basePath + environment.interop.indoc.directie.getDirectiiActive
    private getCompartimenteUrl = this.basePath + environment.interop.indoc.compartiment.getCompartimente
    private getCompartimenteActiveUrl = this.basePath + environment.interop.indoc.compartiment.getCompartimenteActive
    private getCompartimenteByDirectieUrl = this.basePath + environment.interop.indoc.compartiment.getCompartimenteByDirectie
    // private getCompartimenteByIndocUrl = this.basePath + environment.interop.dgaspc.nomenclatoare.compartiment.getCompartimenteByIndoc

    private getUsersUrl = this.basePath + environment.interop.indoc.user.getUserAccess
    private getUsersByOrganigramaUrl = this.basePath + environment.interop.indoc.user.getActiveUsersByOrganigrama
    private getUsersListModuleColeaguesUrl = this.basePath + environment.interop.indoc.user.getUsersListModuleColeagues
    private getFunctiiUrl = this.basePath + environment.interop.indoc.functiiUser.list;

    private getTariActiveUrl = this.basePath + environment.interop.indoc.tari.getTariActive
    private getJudeteActiveUrl = this.basePath + environment.interop.indoc.judete.getJudeteActive
    private getLocalitatiActiveUrl = this.basePath + environment.interop.indoc.localitati.getLocalitatiActive
    private getStraziActiveUrl = this.basePath + environment.interop.indoc.strazi.getStraziActive
    private storeStradaUrl = this.basePath + environment.interop.indoc.strazi.storeStrada

    private getStatusesActiveUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.status.listActive
    private getPrioritiesActiveUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.prioritati.listActive
    private getSeriiActiveUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.serie.listActive
    private getDocumenteActiveUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.tipuri.listActive
    private getSurseActiveUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.surse.listActive
    private getTipuriEntitatiActiveUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.entityTypes.listActive
    private getTipuriFinalizareActiveUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.finalizareTypes.listActive
    private getTipuriAccesActiveUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.categorii.listActive
    private getAdreseRedirectActiveUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.adreseRedirect.listActive;
    private getStatusPostaActiveUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.statusPosta.listActive;
    private getActiveSwitchUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.directieSerii.activeSwitch

    private searchTipDocumenteUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.tipuri.search
    private searchEntitatiUrl = this.basePath + environment.interop.indoc.entitati.searchEntitati
    private searchEntitatiExternUrl = this.basePath + environment.interop.indoc.entitati.searchEntitatiExtern
    private searchEntitatiByCNPUrl = this.basePath + environment.interop.indoc.entitati.searchEntitatiByCNP
    private searchCompartimenteActiveUrl = this.basePath + environment.interop.indoc.compartiment.searchCompartimenteActive

    constructor(private http: HttpClient) { }

    getDirectii() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getDirectiiUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_directie,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get directii active:', error);
                    return throwError(error);
                })
            );
    }

    getDirectiiActive(blocked?: number) {
        let params = new HttpParams();
        if (blocked !== undefined) {
            params = params.set('blocked', blocked);
        }
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getDirectiiActiveUrl, { params }
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_directie,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get directii active:', error);
                    return throwError(error);
                })
            );
    }

    getCompartimente() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCompartimenteUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_compartiment,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get compartimente:', error);
                    return throwError(error);
                })
            );
    }

    getCompartimenteActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCompartimenteActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_compartiment,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get compartimente active:', error);
                    return throwError(error);
                })
            );
    }

    getCompartimenteByDirectieId(id: number, searchInput: string = '') {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCompartimenteByDirectieUrl + id
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_compartiment,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in getCompartimenteByDirectieId:', error);
                    return throwError(error);
                })
            );
    }

    getUsers() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getUsersUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({ id: item.id_user, name: item.name }))
                ),
                catchError((error) => {
                    console.error('Error in getUsers:', error);
                    return throwError(error);
                })
            );
    }

    // old this.getUsersByOrganigramaUrl
    // correct formula, is this:
    getUsersByOrganigrama(data: UserOrganigramaSearchPayload) {
        return this.http
            .post<{ errors: boolean; data: any[]; status_code: number }>(
                this.getUsersUrl, data
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({ id: item.id_user, name: item.name }))
                ),
                catchError((error) => {
                    console.error('Error in getUserTypeActive:', error);
                    return throwError(error);
                })
            );
    }

    getUsersListModuleColeagues(): Observable<Colleague[]> {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getUsersListModuleColeaguesUrl
            )
            .pipe(
                map((response) => response.data),
                catchError((error) => {
                    console.error('Error in get users coleagues:', error);
                    return throwError(error);
                })
            );
    }

    getFunctii() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getFunctiiUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                        active: item.active,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get functii:', error);
                    return throwError(error);
                })
            );
    }

    getTariActive(name?: string) {
        let params = new HttpParams();
        if (name !== undefined) {
            params = params.set('name', name);
        }

        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getTariActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get tari active:', error);
                    return throwError(error);
                })
            );
    }

    getJudeteActive(id_country?: number, name?: string) {
        let params = new HttpParams();
        if (id_country !== undefined && id_country !== -1) {
            params = params.set('id_country', id_country);
        }
        if (name !== undefined) {
            params = params.set('name', name);
        }

        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getJudeteActiveUrl, { params }
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get judete active:', error);
                    return throwError(error);
                })
            );
    }

    getLocalitatiActive(id_country?: number, id_judet?: number, name?: string) {
        let params = new HttpParams();
        if (id_country !== undefined && id_country !== -1) {
            params = params.set('id_country', id_country);
        }
        if (id_judet !== undefined && id_judet !== -1) {
            params = params.set('id_judet', id_judet);
        }
        if (name !== undefined) {
            params = params.set('name', name);
        }

        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getLocalitatiActiveUrl, { params }
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get localitati active:', error);
                    return throwError(error);
                })
            );
    }

    getStraziActive(id_country?: number, id_judet?: number, id_localitate?: number, name?: string) {
        let params = new HttpParams();
        if (id_country !== undefined && id_country !== -1) {
            params = params.set('id_country', id_country);
        }
        if (id_judet !== undefined && id_judet !== -1) {
            params = params.set('id_judet', id_judet);
        }
        if (id_localitate !== undefined && id_localitate !== -1) {
            params = params.set('id_localitate', id_localitate);
        }
        if (name !== undefined) {
            params = params.set('name', name);
        }

        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getStraziActiveUrl, { params }
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get strazi active:', error);
                    return throwError(error);
                })
            );
    }

    storeStrada(
        payload: {
            name: string,
            id_country: number,
            id_judet: number,
            id_localitate: number,
        }
    ) {
        return this.http
            .post<{ errors: boolean; data: any[]; status_code: number }>(
                this.storeStradaUrl, payload
            )
    }

    getStatusesActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getStatusesActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                        // archive: item.archive,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get request statuses active:', error);
                    return throwError(error);
                })
            );
    }

    getPrioritiesActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getPrioritiesActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get request priorities active:', error);
                    return throwError(error);
                })
            );
    }

    getSeriiActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getSeriiActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get request priorities active:', error);
                    return throwError(error);
                })
            );
    }

    getDocumenteActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getDocumenteActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id, name: item.name
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get active docs:', error);
                    return throwError(error);
                })
            );
    }

    getSurseActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getSurseActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id, name: item.name
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get active surse:', error);
                    return throwError(error);
                })
            );
    }

    getTipuriEntitatiActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getTipuriEntitatiActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id, name: item.name
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get active tipuri entitati:', error);
                    return throwError(error);
                })
            );
    }

    getTipuriFinalizareActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getTipuriFinalizareActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id, name: item.name
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get active tipuri finalizare:', error);
                    return throwError(error);
                })
            );
    }

    getTipuriAccesActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getTipuriAccesActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id, name: item.name
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get active tipuri acces:', error);
                    return throwError(error);
                })
            );
    }

    getAdreseRedirectActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getAdreseRedirectActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id, name: item.name, email: item.email
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get active adrese redirect:', error);
                    return throwError(error);
                })
            );
    }

    getStatusPostaActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getStatusPostaActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id, name: item.name
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get active status posta:', error);
                    return throwError(error);
                })
            );
    }


    getActiveSwitch() {
        return this.http
            .put<{ errors: boolean; data: any[]; status_code: number }>(
                this.getActiveSwitchUrl, {}
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: Number(item.id), name: item.name
                    }))
                ),
                catchError((error) => {
                    console.error('Error in active switch:', error);
                    return throwError(error);
                })
            );
    }


    searchTipDocumente(search: string): Observable<Generic[]> {
        return this.http
            .post<{ errors: boolean; data: any[]; status_code: number }>(
                this.searchTipDocumenteUrl, { search }
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => item)
                ),
                catchError((error) => {
                    console.error('Error in search tip documente:', error);
                    return throwError(error);
                })
            );
    }

    searchEntitati(search: string): Observable<SearchEntitate[]> {
        return this.http
            .post<{ errors: boolean; data: any[]; status_code: number }>(
                this.searchEntitatiUrl, { search }
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => item)
                ),
                catchError((error) => {
                    console.error('Error in search entitati:', error);
                    return throwError(error);
                })
            );
    }

    searchEntitatiExtern(search: string): Observable<SearchEntitate[]> {
        return this.http
            .post<{ errors: boolean; data: any[]; status_code: number }>(
                this.searchEntitatiExternUrl, { search }
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => item)
                ),
                catchError((error) => {
                    console.error('Error in search entitati extern:', error);
                    return throwError(error);
                })
            );
    }

    searchEntitatiByCNP(search: string, id_address_type: number): Observable<SearchEntitate[]> {
        return this.http
            .post<{ errors: boolean; data: any[]; status_code: number }>(
                this.searchEntitatiByCNPUrl, { search, id_address_type }
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => item)
                ),
                catchError((error) => {
                    console.error('Error in search entitati by cnp:', error);
                    return throwError(error);
                })
            );
    }

    searchCompartimenteActive(id_directie?: number, name?: string, blocked?: number): Observable<GenericCompartimentSearch[]> {
        let params = new HttpParams();
        if (id_directie !== undefined && id_directie !== -1) {
            params = params.set('id_directie', id_directie);
        }
        if (name !== undefined) {
            params = params.set('name', name);
        }
        if (blocked !== undefined) {
            params = params.set('blocked', blocked);
        }

        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.searchCompartimenteActiveUrl, { params }
            )
            .pipe(
                map((response) => response.data
                ),
                catchError((error) => {
                    console.error('Error in get judete active:', error);
                    return throwError(error);
                })
            );
    }
}
